import React, { Suspense, useCallback, useContext, useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { TostMsg } from "../../../App";
// import { getTicketListData, addTicket } from "./TicketService";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import Papa from "papaparse";
import { saveAs } from "file-saver";
import moment from "moment";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Chart } from "primereact/chart";
import { deleteAsset, getAsset } from "./Services/assetsService";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";


function AssetsList() {
  const defaultImage = "/images/placeholder_profile.png";
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [Isloading, setIsloading] = useState(false);
  const toster = useContext(TostMsg);
  const [ticketDataCount, setTicketDataCount] = useState([]);
  const [noData, setNoData] = useState([]);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");

  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});
  const [ticketData, setTicketData] = useState([]);
  const [dashboardCount, setDashboardCount] = useState({});
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);   // starting row
  const [rows, setRows] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [assestDeleteId, setAssestDeleteId] = useState()
  const [selectAsset, setSelectAsset] = useState([]);


  function exportToPDF() {
    if (!selectAsset || selectAsset.length === 0) {
      toster.current.warn("Please select at least one record");
      return;
    }

    const doc = new jsPDF();

    const tableColumn = [
      "Asset Serial No",
      "Asset Name",
      "Asset Type",
      "Serial Number",
      "Status",
      "Model",
      "Make",
      "Size",
      "Description",
    ];

    const tableRows = selectAsset.map((row) => [
      row.ItemNumber,
      row.ItemName,
      row.TypeName,
      row.SerialNumber,
      row.StatusName,
      row.Model,
      row.Make,
      row.Size,
      row.Description,
    ]);

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
    });

    doc.save("Assets_Report.pdf");
  }

  function exportToCSV() {
    if (!selectAsset || selectAsset.length === 0) {
      toster.current.warn("Please select at least one record");
      return;
    }

    const exportData = selectAsset.map((row) => ({
      "Asset Serial No": row.ItemNumber,
      "Asset Name": row.ItemName,
      "Asset Type": row.TypeName,
      "Serial Number": row.SerialNumber,
      "Status": row.StatusName,
      "Model": row.Model,
      "Make": row.Make,
      "Size": row.Size,
      "Description": row.Description,
    }));

    const csv = Papa.unparse(exportData);

    const blob = new Blob([csv], {
      type: "text/csv;charset=utf-8;",
    });

    saveAs(blob, "Assets_Report.csv");
  }

  useEffect(() => {
    getAssestList(1, rows, searchText);
  }, []);

  useEffect(() => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue("--text-color");
    const textColorSecondary = documentStyle.getPropertyValue(
      "--text-color-secondary"
    );
    const surfaceBorder = documentStyle.getPropertyValue("--surface-border");
    const data = {
      labels: ["Laptop", "Chair", "Table", "Server", "AC", "Fan", "Light"],
      datasets: [
        {
          type: "bar",
          label: "Ready for Use",
          backgroundColor: documentStyle.getPropertyValue("--purple-700"),

          data: [50, 25, 12, 48, 90, 76, 42],
        },
        {
          type: "bar",
          label: "Under Repair Process",
          backgroundColor: documentStyle.getPropertyValue("--yellow-500"),

          data: [21, 84, 24, 75, 37, 65, 34],
        },
        {
          type: "bar",
          label: "Rejected",
          backgroundColor: documentStyle.getPropertyValue("--red-600"),
          data: [41, 52, 24, 74, 23, 21, 32],
        },
      ],
    };
    const options = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        tooltips: {
          mode: "index",
          intersect: false,
        },
        legend: {
          labels: {
            color: textColor,
          },
        },
      },
      scales: {
        x: {
          stacked: true,
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
          },
        },
        y: {
          stacked: true,
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
          },
        },
      },
    };

    setChartData(data);
    setChartOptions(options);
  }, []);

  async function getAssestList(pageNumber = 1, pageSize = rows, search = searchText) {
    setIsloading(true);
    const params = {
      OrgId: userDetails.OrgId,
      LoggedInUserId: userDetails.OrgId,
      SearchTerm: search || "",
      GuId: "",
      PageNumber: pageNumber,
      PageSize: pageSize,
    };
    try {
      let response = await getAsset(params);
      const dashboard = response?.Data?.invDashboardCount || {};
      const list = response?.Data?.invListResponses || [];
      setDashboardCount(dashboard);
      setTicketData(list);
      setTotalRecords(dashboard?.TotalAssets || 0);
    } catch (error) {
      console.log(error);
    }
    setIsloading(false);
  }

  const handleInputChange = (e) => {
    const value = e.target.value;

    setSearchText(value);
    setFirst(0); 

    getAssestList(1, rows, value);
  };

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);

    const pageNumber = event.page + 1;

    getAssestList(pageNumber, event.rows, searchText);
  };


  async function deleteAssest() {
    if (!assestDeleteId) return;
    let body = {
      ItemId: assestDeleteId,
      ModifiedBy: userDetails?.EmpId,
      LoggedInId: userDetails?.EmpId
    };

    try {
      await deleteAsset(body);
      getAssestList(1, rows, searchText);
      setAssestDeleteId(null);
    } catch (error) {
      console.log(error);
    }
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ gap: "5px" }}
      >
        <Link to={`/Profile/${rowData.GUID}`} className="view-teamdetail">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-eye"
            viewBox="0 0 16 16"
          >
            <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
            <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
          </svg>
        </Link>

        <Link className="view-teamdetail">
          <svg
            // onClick={() => redirectToAnotherPage(rowData)}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-chat-text"
            viewBox="0 0 16 16"
          >
            <title>Chat</title>
            <path d="M2.678 11.894a1 1 0 0 1 .287.801 11 11 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8 8 0 0 0 8 14c3.996 0 7-2.807 7-6s-3.004-6-7-6-7 2.808-7 6c0 1.468.617 2.83 1.678 3.894m-.493 3.905a22 22 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a10 10 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9 9 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105" />
            <path d="M4 5.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8m0 2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5" />
          </svg>
        </Link>
      </div>
    );
  };

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>
        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      <div className="container-fluid  position-relation">
        <div className="row">
          <div className="col-xl-12">
            <div className="form-head d-flex flex-wrap align-items-center mb-4">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">Assets Dashboard</h2>
              </div>
              <div className="rightside-tabs">
                <Link to="/Assets/add">
                  <button className="add-newticket w-auto float-right ">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-plus"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                    </svg>{" "}
                    Add Assets
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <div className="page-content-inner all-projects">
              <div className="row">
                <div className="col-lg-6">
                  <div className="assets-summary tickets-summary">
                    <div className="column">
                      <img src="/images/org-img/leave/popup-backimg.png" />
                      <Link to="">
                        <span>{dashboardCount?.InWarranty || 0}</span>
                        <div>
                          <p>Assets in Warrenty</p>
                        </div>
                      </Link>
                      <div className="progress">
                        <div
                          className="progress-bar bg-success"
                          role="progressbar"
                          style={{ width: "25%" }}
                          aria-valuenow="25"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>

                    <div className="column">
                      <img src="/images/org-img/leave/popup-backimg.png" />
                      <Link to="">
                        <span>{dashboardCount?.AssetsInStock || 0}</span>
                        <div>
                          <p>Assets in stack</p>
                        </div>
                      </Link>
                      <div className="progress">
                        <div
                          className="progress-bar bg-success"
                          role="progressbar"
                          style={{ width: "25%" }}
                          aria-valuenow="25"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>

                    <div className="column">
                      <img src="/images/org-img/leave/popup-backimg.png" />
                      <Link to="">
                        <span>{dashboardCount?.TotalAssets || 0}</span>
                        <div>
                          <p>Total Assets</p>
                        </div>
                      </Link>
                      <div className="progress">
                        <div
                          className="progress-bar bg-success"
                          role="progressbar"
                          style={{ width: "25%" }}
                          aria-valuenow="25"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>

                    <div className="column">
                      <img src="/images/org-img/leave/popup-backimg.png" />
                      <Link to="">
                        <span>{dashboardCount?.NewAssets || 0}</span>
                        <div>
                          <p>New Assets</p>
                        </div>
                      </Link>
                      <div className="progress">
                        <div
                          className="progress-bar bg-success"
                          role="progressbar"
                          style={{ width: "25%" }}
                          aria-valuenow="25"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="asset-chart">
                    <Chart type="bar" data={chartData} options={chartOptions} />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-12 mt-5">
            <div className="card">
              <div className="card-body">
                <div className="form-head d-flex flex-wrap align-items-center mb-3">
                  <div className="me-auto w-20">
                    <strong
                      className="ticket-title m-0"
                      style={{ fontWeight: "bolder" }}
                    >
                      Asstes ({totalRecords})
                    </strong>
                  </div>
                  <div className="actionbutton-tickets">
                    <InputText
                      name="requestTitle"
                      className="form-control mr-2"
                      placeholder="Search"
                      onChange={handleInputChange}
                    />
                    <div className="dropdown documents-dropdown">
                      <button

                        className="btn btn-purple me-2"
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <svg

                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-download me-1"
                          viewBox="0 0 16 16"
                        >
                          <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                          <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                        </svg>{" "}
                        Download
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li>
                          <a className="dropdown-item"  style={{cursor: "pointer"}} onClick={exportToPDF}>
                            PDF Report
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item"  style={{cursor: "pointer"}} onClick={exportToCSV} >
                            Excel Report
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* <div className="form-head d-flex flex-wrap align-items-center bottom-head">
                  <div className="saving-btn00 d-flex w-100 assets-field">
                    <div className="d-flex d-flexx">
                      <MultiSelect
                        name="assignToName"
                        className="w-full "
                        value={selectedAssingToName}
                        onChange={(e) => {
                          setSelectedAssingToName(e.value);
                          handleInputChange(e);
                        }}
                        options={employeDetails}
                        optionLabel="FullName"
                        filter
                        placeholder="Asset Type"
                        maxSelectedLabels={3}
                        selectedItemsLabel="{0} Assign to selected"
                        itemTemplate={employeeOptionTemplate}
                      />

                      <MultiSelect
                        name="assignToName"
                        className="w-full"
                        value={selectedRaiseBy}
                        onChange={(e) => {
                          setSelectedRaiseBy(e.value);
                          handleInputChange(e);
                        }}
                        options={employeDetails}
                        optionLabel="FullName"
                        filter
                        placeholder="Asset Owner"
                        maxSelectedLabels={3}
                        selectedItemsLabel="{0} Raise by selected"
                        itemTemplate={employeeOptionTemplate}
                      />

                      <MultiSelect
                        name="requestStatus"
                        value={selectedTableStatus}
                        onChange={(e) => {
                          setSelectedTableStatus(e.value);
                          handleInputChange(e);
                        }}
                        options={ticketStatusType}
                        optionLabel="Name"
                        filter
                        maxSelectedLabels={3}
                        selectedItemsLabel="{0} Status selected"
                        placeholder="Warranty Status"
                        className="w-full "
                      />
                      <MultiSelect
                        name="requestStatus"
                        value={selectedTableStatus}
                        onChange={(e) => {
                          setSelectedTableStatus(e.value);
                          handleInputChange(e);
                        }}
                        options={ticketStatusType}
                        optionLabel="Name"
                        filter
                        maxSelectedLabels={3}
                        selectedItemsLabel="{0} Status selected"
                        placeholder="Assets Status"
                        className="w-full "
                      />
                    </div>
                  </div>
                </div> */}
                <div className="row">
                  <div className="table table-bordered dataTable no-footer tickettable assettable">
                    <DataTable
                      value={ticketData}
                      lazy
                      paginator
                      first={first}
                      rows={rows}
                      totalRecords={totalRecords}
                      onPage={onPageChange}
                      responsiveLayout="scroll"
                      dataKey="GUID"
                      loading={Isloading}
                      emptyMessage="No data available"
                      className="p-datatable-striped"

                      selection={selectAsset}
                      onSelectionChange={(e) => setSelectAsset(e.value)}
                      selectionPageOnly={false}
                    >
                      <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                      <Column
                        field="ItemNumber"
                        header="Asset Serial No"
                        style={{ minWidth: "10rem" }}
                      />
                      <Column
                        field="ItemName"
                        header="Asset Name"
                        style={{ minWidth: "10rem" }}
                      />
                      <Column field="TypeName" header="Asset Type" />
                      <Column field="SerialNumber" header="Serial Number" />
                      <Column field="StatusName" header="Status" />
                      <Column field="Model" header="Model" />
                      <Column field="Make" header="Make" />
                      <Column field="Size" header="Size" />
                      <Column field="Description" header="Description" />

                      <Column
                        field="CreatedDate"
                        header="Created Date"
                        body={(rowData) =>
                          moment(rowData.CreatedDate).format("MMM DD, YYYY")
                        }
                      />
                      {/* <Column field="EmployeeFullName" header="Mac Address" />
                      <Column field="RequestStatus" header="Status" />
                      <Column field="CategoryName" header="Description" />
                      <Column
                        field="SubCategoryName"
                        header="Date of Purchase"
                      />
                      <Column field="AssignToName" header="Purchase Month" />
                      <Column field="PriorityName" header="Purchase Year" />

                      <Column field="VendorName" header="Vendor" />
                      <Column field="SeverityName" header="RAM" />
                      <Column field="Brand" header="Brand" />
                      <Column field="Processor" header="Processor" />
                      <Column field="Gen" header="Gen" />
                      <Column field="Storage" header="Storage" />
                      <Column field="CurrentOwner" header="Current Owner" />
                      <Column
                        field="Operating System"
                        header="Operating System"
                      />
                      <Column field="CurrentIP" header="Current IP" />
                      <Column
                        field="LastIssuedDate"
                        header="Last Issued Date"
                      />
                      <Column field="IssueLetter" header="Issue Letter No" /> */}
                      <Column
                        header="Action"
                        body={
                          (rowData) => (
                            <div className="d-flex">
                              <Link to={`/Assets/Edit/${rowData.GUID}`}>
                                <button className="editactions me-2">
                                  <img
                                    src="/images/tickets/edit-ico.svg"
                                    title="Edit"
                                  />
                                </button></Link>
                              <button className="editactions me-2" title="Delete">
                                <img
                                  src="/images/tickets/delete.svg"
                                  title="Delete"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-bs-toggle="modal"
                                  data-bs-target="#delete-ed"
                                  data-bs-original-title="delete"
                                  aria-label="delete"
                                  onClick={() => setAssestDeleteId(rowData.Id)}
                                />
                              </button>
                              <Link to={`/Assets/Detail/${rowData.GUID}`}>
                                <button className="editactions me-2" title="View">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-eye"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                                    <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                                  </svg>
                                </button>
                              </Link>

                              <a className=" me-2" title="Transfer">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-arrow-left-right"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5m14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5"
                                  />
                                </svg>
                              </a>
                              <a className="" title="">
                                Return to Inventory
                              </a>
                            </div>
                          )
                        }
                        style={{ width: "361px" }}
                      ></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="review-request"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title m-auto">
                Form Submitted Successfully. Now Sent the Review Request.
              </h5>
            </div>
            <div className="modal-body text-center">
              <form>
                <div className="form-group text-left">
                  <label>Request to</label>
                  <select className="default-select form-control wide mb-3">
                    <option selected disabled>
                      Select
                    </option>
                    <option>Employee Review</option>
                    <option>Review</option>
                    <option>HR Review</option>
                  </select>
                </div>
                <div className="form-group text-left">
                  <label className="mt-3">Add your Comment</label>
                  <textarea
                    rows="4"
                    cols="1"
                    className="form-control"
                  ></textarea>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger light"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button type="button" className="btn btn-primary">
                Sumbit
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="delete-ed">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>Do you really want to delete this Assest?</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="savebtn-click"
                data-bs-dismiss="modal"
                onClick={() => deleteAssest()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      {Isloading ? (
        <Suspense fallback={<div>Loading...</div>}>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}

export default AssetsList;
